module.exports = __webpack_public_path__ + "static/banner-image-27edc4c2d0540e5b7a9755f77301a474.png";